import { create } from 'zustand';
import {
    UserActivityListItemDto,
    UserActivitySourceFilter,
} from '@/features/superAdmin/features/userActivities/types/superAdmin-userActivities-dto';

const TODAY = new Date();
const DEFAULT_PAGE_SIZE = 10;

type UserActivitiesFilterType = {
    filter: {
        startDate: Date;
        endDate: Date;
        take: number;
        skip: number;
        orderBy: string | null;
        orderDirection: 'asc' | 'desc';
        source: UserActivitySourceFilter;
        userId: string | null;
        tenantId: string | null;
        searchText: string;
    };
    setFilter: (filter: Partial<UserActivitiesFilterType['filter']>) => void;
    resetFilter: () => void;
};

const defaultState: UserActivitiesFilterType['filter'] = {
    startDate: TODAY,
    endDate: TODAY,
    take: DEFAULT_PAGE_SIZE,
    skip: 0,
    orderBy: null,
    orderDirection: 'desc',
    source: null,
    userId: null,
    tenantId: null,
    searchText: '',
};

export const useUserActivitiesFilter = create<UserActivitiesFilterType>((set) => ({
    filter: { ...defaultState },
    setFilter: (newFilter) => {
        set((state) => ({
            filter: {
                ...state.filter,
                ...newFilter,
            },
        }));
    },
    resetFilter: () => {
        set({
            filter: { ...defaultState },
        });
    },
}));
